// extracted by mini-css-extract-plugin
export var collapsedSummary = "_py-0";